import _ from 'lodash';

const roundDataValues = (data) => {
    _.forEach(data, (value, key) => {
        data[key] = isNaN(value) ? parseFloat(value || 0) : parseFloat(parseFloat(value).toFixed(2));
    });
    return data;
};

export { roundDataValues }
